<script setup>
defineProps({
  lead: {
    type: Object,
    required: true,
  },
});
</script>

<template>
  <div class="article-lead">
    <PostContent is-lead :content="lead" />
  </div>
</template>
